// Tiny cache helper with TTL and structured logging

export function getCache(key, ttlMs) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) { return null; }
    const parsed = JSON.parse(raw);
    const age = Date.now() - (parsed.savedAt || 0);
    if (ttlMs != null && age > ttlMs) { return null; }
    return parsed.data;
  } catch (e) {
    return null;
  }
}

export function setCache(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ savedAt: Date.now(), data }));
  } catch (e) {
  }
}

export function invalidateCache(...keys) {
  for (const key of keys) {
    try {
      localStorage.removeItem(key);
    } catch {}
  }
}


